// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { UserViewModel } from './userview-model';
import { SchoolClassViewModel } from './schoolclassview-model';


export class TeacherSchoolClassesViewModel {
    currentUser: UserViewModel = null;
	schoolClasses: SchoolClassViewModel[] = null;
	pageNumber: number = 0;
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        
	}
}